/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Scan_Invalid_QrInputs */

const vi_lot_scan_invalid_qr = /** @type {(inputs: Lot_Scan_Invalid_QrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã QR không phải là tem lô hợp lệ`)
};

/**

* @param {Lot_Scan_Invalid_QrInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_scan_invalid_qr = /** @type {((inputs?: Lot_Scan_Invalid_QrInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Scan_Invalid_QrInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_scan_invalid_qr(inputs)
});